import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Uses localStorage
import { persistReducer, persistStore } from "redux-persist";

// Import slices
import OrdersSlice from "../reduxSlice/admin/OrdersSlice";
import UtilsSlice from "../utilsSlice/UtilsSlice";
import ProductSlice from "../reduxSlice/admin/ProductSlice";
import CollactionSlice from "../reduxSlice/admin/CollactionSlice";
import CustomerSlice from "../reduxSlice/admin/CustomerSlice";
import PurchaseOderSlice from "../reduxSlice/admin/PurchaseOrderSlice";
import SingInSlice from "../reduxSlice/SingIn&Singup/SingInSlice";
import AdminSingInSlice from "../reduxSlice/SingIn&Singup/AdminSingInSlice";

import TagSlice from "../reduxSlice/admin/TagSlice";
import SupplierSlice from "../reduxSlice/admin/SupplierSlice";
import ProductsSlice from "../reduxSlice/website/ProductsSlice";
import BlogCategorySlice from "../reduxSlice/admin/BlogCategorySlice";
import CartCountSlice from "../reduxSlice/website/CartSlice";
import BlogListSlice from "../reduxSlice/admin/BlogListSlice";
import WishlistSlice from "../reduxSlice/website/WishlistSlice";
import WebOrdersSlice from "../reduxSlice/website/WebOrdersSlice";
import getCategoriesFullDataSlice from "../reduxSlice/website/getCategoriesFullDataSlice";
import BrandSlice from "../reduxSlice/admin/BrandSlice";
import { lazy } from "react";
import ProductReviewSlice from "../reduxSlice/website/ProductReviewSlice";
import CoustomerAddressSlice from "../reduxSlice/website/CoustmoerAdderssSlice";
import AdminProductReviewSlice from "../reduxSlice/admin/ProductReviewSlice";
import getMappingListSlice from "../reduxSlice/admin/MappingSlice";
import PriceListSlice from "../reduxSlice/admin/PriceListSlice";
import makeYearModelReducer from "../reduxSlice/website/MakeYearModel";
import SignUpSlice from "../reduxSlice/SingIn&Singup/SingUpSlice";
// Redux Persist Configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["SingIn", "AdminSingIn"], // Only persist authentication slices
};

// Combine reducers
const rootReducer = combineReducers({
  orders: OrdersSlice,
  products: ProductSlice,
  customers: CustomerSlice,
  collactions: CollactionSlice,
  PurchaseOders: PurchaseOderSlice,
  utils: UtilsSlice,
  tags: TagSlice,
  SignUp: SignUpSlice,
  SingIn: SingInSlice, // Persisted
  AdminSingIn: AdminSingInSlice, // Persisted
  Supplier: SupplierSlice,
  BlogCategory: BlogCategorySlice,
  product: ProductsSlice,
  Cart: CartCountSlice,
  BlogList: BlogListSlice,
  Wishlist: WishlistSlice,
  order: WebOrdersSlice,
  CategoriesFullData: getCategoriesFullDataSlice,
  Brand: BrandSlice,
  ProductReviews: ProductReviewSlice,
  CoustomerAddress: CoustomerAddressSlice,
  AdminProductReview: AdminProductReviewSlice,
  MappingList: getMappingListSlice,
  PriceList: PriceListSlice,
  MakeYearModel: makeYearModelReducer
});

// Apply persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required to prevent serialization errors
    }),
});

// Create Persistor
export const persistor = persistStore(store);
